// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

const updatePrezStaticFile = async ({ sports, name, url }) => {
  try {
    const prezStaticFile = await axios.post(
      "/api/shared/update-prez-static-file",
      { sports, name, url }
    );
    return prezStaticFile.data;
  } catch (error) {
    console.error("Utils - Get hub satus - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.GET_RECORD);
  }
};

export default updatePrezStaticFile;
